import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaWarehouse, FaBoxOpen, FaTruck, FaCheckCircle, FaPhone } from 'react-icons/fa';
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";

import '../../assets/css/armazenagem.css'; // CSS específico para esta página

const Armazenagem = () => {

  // Array com as imagens da galeria
const galleryImages = [
  { 
    id: 1, 
    src: '/img/armazenagem/0.jpg', 
    alt: 'Armazenagem climatizada para pianos' 
  },
  { 
    id: 2, 
    src: '/img/armazenagem/2.jpg', 
    alt: 'Espaço seguro com monitoramento 24h' 
  },
  { 
    id: 3, 
    src: '/img/armazenagem/3.jpg', 
    alt: 'Transporte especializado para retirada' 
  },


];

const armazenagemSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Serviço de Armazenagem de Pianos",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Oferecemos serviço de armazenagem de pianos com transporte especializado, ideal para quem está de mudança ou reformando. Amplo espaço seguro e vistoria técnica gratuita.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/armazenagem"
};


  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];


  return (
    <div className="armazenagem-container">
      <SeoHead
  title="Serviço de Armazenagem de Pianos | Waldir Pianos"
  description="Guarde seu piano com segurança durante mudanças ou reformas. Transporte especializado, espaço amplo e vistoria técnica gratuita."
  keywords="armazenagem piano, guarda piano, depósito piano, transporte piano, Waldir Pianos"
  image="/img/armazenagem/1.jpg" /* Exemplo de caminho de imagem */
  url="https://pianoswaldir.com.br/armazenagem"
  canonicalUrl="https://pianoswaldir.com.br/armazenagem"
  schemaMarkup={armazenagemSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="armazenagem-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="armazenagem-header-content">
          <motion.h1
            className="armazenagem-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaWarehouse className="armazenagem-title-icon" />
            Serviço de Armazenagem
            <span className="armazenagem-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="armazenagem-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Segurança e cuidado para o seu piano
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="armazenagem-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="armazenagem-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="armazenagem-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="armazenagem-section-title">
              <FaBoxOpen className="armazenagem-section-icon" />
              Solução Temporária para seu Piano
            </h2>

            <p className="armazenagem-classic-text">
              "Para quem está de mudança, ou reformando a casa e precisa armazenar o piano em outro local temporariamente. Possuímos um amplo espaço e oferecemos serviço de armazenagem com transporte de retirada e entrega especializado, além de vistoria técnica gratuita."
            </p>

            <div className="armazenagem-modern-text">
              <p>Nossos espaços de armazenagem são climatizados e seguros, garantindo a proteção do seu instrumento contra variações de temperatura, umidade e poeira.</p>
              <p>Contamos com uma equipe experiente para o manuseio e transporte de pianos, assegurando que seu instrumento seja tratado com o máximo cuidado desde a retirada até a entrega de volta ao seu lar.</p>
            </div>

            <div className="armazenagem-benefits-grid">
              <div className="armazenagem-benefit-item">
                <FaWarehouse className="armazenagem-benefit-icon" />
                <span>Amplo espaço climatizado</span>
              </div>
              <div className="armazenagem-benefit-item">
                <FaTruck className="armazenagem-benefit-icon" />
                <span>Transporte especializado (retirada e entrega)</span>
              </div>
              <div className="armazenagem-benefit-item">
                <FaCheckCircle className="armazenagem-benefit-icon" />
                <span>Vistoria técnica gratuita inclusa</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

        {/* Galeria (Opcional - Placeholder se não houver imagens específicas) */}
        {/* Remover ou adaptar se não houver necessidade de galeria */}
    <motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Nosso Espaço de Armazenagem</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="armazenagem-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="armazenagem-footer-text">Precisa de um local seguro para seu piano?</p>
        <motion.a
          href="tel:1122565987"
          className="armazenagem-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default Armazenagem;